import { render, staticRenderFns } from "./load-local-attachment.vue?vue&type=template&id=923a2778&scoped=true&"
import script from "./load-local-attachment.vue?vue&type=script&lang=js&"
export * from "./load-local-attachment.vue?vue&type=script&lang=js&"
import style0 from "./load-local-attachment.vue?vue&type=style&index=0&id=923a2778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923a2778",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
